import { memo } from 'react';
import { TabList as RACTabList, TabListProps as RACTabListProps } from 'react-aria-components';

import { merge } from '@/components';

export type TabListProps<TTabData extends object> = RACTabListProps<TTabData>;

const ITabList = <TTabData extends object>({ className, children, ...rest }: TabListProps<TTabData>) => {
  const styles = [
    'flex',
    'gap-xs',

    /* Model Panel */
    'group-[*]/model-panel:border-b-2',
    'group-[*]/model-panel:border-gray-200',
    'group-[*]/model-panel:p-0',
    'group-[*]/model-panel:mx-md',
    'group-[*]/model-panel:my-sm',
  ];

  return (
    <RACTabList<TTabData> className={merge(styles, className)} {...rest}>
      {typeof children === 'function' ? (item) => children(item) : children}
    </RACTabList>
  );
};

export const TabList = memo(ITabList) as typeof ITabList;
